import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

export default styled.div`
	height: 100%;

	.layout-slider {
		height: 100%;
		min-height: 30em;
	}

	.slick-slider {
		position: relative;
		z-index: 9;

		.slick-list {
			overflow: inherit;
			overflow-x: clip;

			.slick-track {
				display: flex;
				justify-content: center;
				align-items: center;

				.slick-slide {
					margin: 0 0.5em;
				}
			}
		}

		.slick-arrow {
			z-index: 999;

			&.slick-prev {
				transition: transform 0.3s ease-in-out;
				left: -2%;

				&:before {
					content: '<';
					color: #000000;
					font-size: 40px;
				}
				&:hover {
					transform: translate(-50%, -50%);
				}
			}
			&.slick-next {
				transition: transform 0.3s ease-in-out;
				right: -2%;

				&:before {
					content: '>';
					color: #000000;
					font-size: 40px;
				}
				&:hover {
					transform: translate(50%, -50%);
				}
			}
		}

		.slick-dots {
			position: absolute;
			display: flex !important;
			justify-content: center;
			align-items: center;
			bottom: -4em;
			left: 50%;
			transform: translateX(-50%);
			width: max-content;
			height: 2.2em;
			margin: 0 auto;
			padding: 0.5em 0.7em;
			border-radius: 1em;
			background-color: #404040;			

			li {
				max-width: 2.5em;
				width: 2em;
				margin: 0.2em;
				background-color: ${vars.colorPrimaryWhite};
				border-radius: 1em;
				height: 0.9em;

				&.slick-active {
					background-color: ${vars.colorPrimaryGreen};
				}
			}
		}
	}

	.slick-prev::before,
	.slick-next::before {
		display: none;
	}

	@media all and (max-width: ${vars.mobileM}) {
		.slick-slider {
			.slick-list {
				.slick-track {
					.slick-slide {
						opacity: 0.3;
					}

					.slick-active {
						opacity: 1;
					}
				}
			}

			.slick-arrow {
				&.slick-prev {
					left: 7%;
				}
				&.slick-next {
					right: 7%;
				}
			}

			.slick-dots {
				li {
					width: 2.5em;
					margin: 0.1em;
				}
			}
		}
	}
`;
